import {
  curry,
  map,
  adjust,
  omit,
  pick,
  reject,
  merge,
  fromPairs,
  toPairs,
} from 'ramda';

/**
 * Transform keys of an object
 * Usage: mapKeys(R.toUpper, {a: 1, b:2, c:3}); // {A: 1, B:2, C:3}
 */
export const mapKeys = curry((fn, obj) =>
  fromPairs(map(adjust(fn, 0), toPairs(obj))),
);

/**
 * Omit a key when it's value is equal to a certain value
 * Usage: omitWhen(R.equals(2), ['a', 'c'], { a: 1, b: 1, c: 2, d: 2 }); // { a: 1, b: 1, d: 2 }
 */
export const omitWhen = curry((fn, ks, obj) =>
  merge(omit(ks, obj), reject(fn, pick(ks, obj))),
);

const objectsPropsMatch = (a, b, prop) => {
  return (
    Object.prototype.hasOwnProperty.call(a, prop) ===
    Object.prototype.hasOwnProperty.call(b, prop)
  );
};
export const compareObjectsDeep = (a, b) => {
  if (typeof a !== typeof b) return false;
  if (Array.isArray(a) !== Array.isArray(b)) return false;
  for (const prop in a) {
    if (!objectsPropsMatch(a, b, prop)) return false;
    switch (typeof a[prop]) {
      case 'object':
        if (!compareObjectsDeep(a[prop], b[prop])) return false;
        break;
      default:
        if (a[prop] !== b[prop]) return false;
        break;
    }
  }
  // check "b" doesn't have extra props
  for (const prop in b) {
    if (!objectsPropsMatch(a, b, prop)) return false;
  }
  return true;
};

export const isObjectEmpty = (obj) => {
  for (const _ in obj) return false;
  return true;
};
